import { useMemo } from "react";

import { SideNavigationMobileItemType, NavigationMobileConfigType } from "types/Navigation";
import { CodeBrowser, GridTilesMasonry, Package, Stack } from "components/icons/generated";

type UseNavigationConfigProps = {
  isAdmin: boolean;
};

const useNavigationMobileConfig = ({
  isAdmin,
}: UseNavigationConfigProps): NavigationMobileConfigType => {
  return useMemo<NavigationMobileConfigType>(
    () => ({
      ...(isAdmin
        ? {
            [SideNavigationMobileItemType.Dashboard]: {
              title: "Dashboard",
              icon: GridTilesMasonry,
              to: "/dashboard",
              rule: ["/dashboard"],
            },
          }
        : {}),
      [SideNavigationMobileItemType.Stacks]: {
        title: "Stacks",
        icon: Stack,
        to: "/stacks",
        rule: ["/stack", "/new/stack"],
        id: () => "stacks-navigation-item",
      },
      [SideNavigationMobileItemType.Blueprints]: {
        title: "Blueprints",
        icon: CodeBrowser,
        to: "/blueprints",
        rule: ["/blueprint"],
      },
      [SideNavigationMobileItemType.Modules]: {
        icon: Package,
        title: "TF registry",
        to: "/modules",
        rule: ["/module", "/provider", "/gpg-key", "/new/module", "/shared-modules"],
      },
    }),
    [isAdmin]
  );
};

export default useNavigationMobileConfig;
